import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import app_storage from './plugins/storage'
import axios from "./plugins/axios";

import './theme'

const app = createApp(App)

// Components
import Alert from './components/Alert'
app.component('alert', Alert)

import Loading from './components/Loading'
app.component('loading', Loading)

import Schedule from './components/Schedule'
app.component('schedule', Schedule)

import DatePicker from 'vue3-datepicker'
app.component('date-picker', DatePicker)

// Plugins
app.use(store)

app.use(router)

app.config.globalProperties.$axios = axios;

app.config.globalProperties.$storage = app_storage;

app.mount('#app')
